import { VisitEncounterMode, VisitQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { Dropdown, LinkIconVariant, LinkVariant } from '@dreryk/react-components';

import {
   useVisitEncounterModeDropdownItemsConfiguration,
   useVisitUpdateEncounterModeCommand,
} from './VisitEncounterModeDropdown.hooks';
import { VisitEncounterModeIcon } from './VisitEncounterModeIcon';

type VisitEncounterModeDropdownProps = {
   patientId: number;
   visitId: number;
   visitEncounterMode: VisitEncounterMode;
};

export const VisitEncounterModeDropdown = (props: VisitEncounterModeDropdownProps): JSX.Element => {
   const { executeAsync: updateVisitEncounterMode } = useVisitUpdateEncounterModeCommand({
      visitId: props.visitId,
      onSuccess: () => {
         refetchCqrsQuery(VisitQuery);
      },
   });

   const dropdownItemsConfiguration = useVisitEncounterModeDropdownItemsConfiguration({
      onUpdateVisitEncounterMode: updateVisitEncounterMode,
      patientId: props.patientId,
   });

   const selectedDropdownItem = dropdownItemsConfiguration[props.visitEncounterMode];

   return (
      <Dropdown
         testId={'visitEncounterMode'}
         triggerLabel={selectedDropdownItem.label}
         triggerIcon={<VisitEncounterModeIcon icon={selectedDropdownItem.icon} />}
         variant={LinkVariant.STANDARD}
         triggerIconSuffixVariant={LinkIconVariant.PRIMARY}
         maxWidth={176}
      >
         {Object.entries(dropdownItemsConfiguration).map(([, dropdownItem]) => dropdownItem.item)}
      </Dropdown>
   );
};
